// 📁 src/financial_reports/hooks/useDownloadPDF.js
import { useState } from "react";
import { pdf } from "@react-pdf/renderer";

export default function useDownloadPDF() {
  const [isGenerating, setIsGenerating] = useState(false);

  const generateAndDownload = async (PDFComponent, fileName = "report.pdf") => {
    if (!PDFComponent) return;
    setIsGenerating(true);

    try {

      // ✅ Let React render "Generating PDF..." first
      await new Promise(resolve => setTimeout(resolve, 50));

      // ✅ Reset React-PDF internal cache
      if (typeof pdf.reset === "function") {
        pdf.reset();
      }
      
      const blob = await pdf(PDFComponent).toBlob();

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("PDF generation failed:", err);
      alert("Failed to generate PDF. Please try again.");
    } finally {
      setIsGenerating(false);
    }
  };

  return { generateAndDownload, isGenerating };
}
